module.exports = __webpack_public_path__ + "img/leaves.31dbc534.png";